import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-pop-up-body',
  templateUrl: './pop-up-body.component.html',
  styleUrls: ['./pop-up-body.component.scss']
})
export class PopUpBodyComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
